const PropTypes = require('prop-types');
const React = require('react');
const { cmsPagePath } = require('components/shared/url_helpers.js');
const Tooltip = require('components/tooltip');

class SignatureRequiredInput extends React.Component {
  showChecked() {
    return this.props.defaultChecked || this.props.required;
  }

  disabledValue() {
    if (this.props.required) {
      return 'disabled';
    }
    return '';
  }

  checkedValue() {
    if (this.showChecked()) {
      return 'checked';
    }
    return '';
  }

  hiddenFieldValue() {
    if (this.showChecked()) {
      return '1';
    }
    return '0';
  }

  onChange() {
    if (this.props.required) return false;
    this.props.toggleSignatureRequired();
    return true;
  }

  sellerProtectionLink() {
    return cmsPagePath('reverb-protection');
  }

  signatureExplanationLink() {
    if (this.props.required) {
      return I18n.t('js.dashboard.selling.shippingLabels.signatureRequired.requiredExplanationHtml', { linkOpen: `<a href=${this.sellerProtectionLink()}>`, linkClose: '</a>' });
    }
    return I18n.t('js.dashboard.selling.shippingLabels.signatureRequired.optionalExplanationHtml', { linkOpen: `<a href=${this.sellerProtectionLink()}>`, linkClose: '</a>' });
  }

  showWarning() {
    return (
      <div className="shipping-label__checkbox-hint">
        <span
          className="mr-half"
          dangerouslySetInnerHTML={{ __html: this.signatureExplanationLink() }}
        />
        <Tooltip
          title={I18n.t('js.dashboard.selling.shippingLabels.signatureRequired.tooltip')}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="mb-1">
        <div className="label-with-checkbox">
          <input
            name="shipping_label_form[signature_required]"
            type="hidden"
            value={this.hiddenFieldValue()}
          />
          <input
            onChange={() => this.onChange()}
            disabled={this.disabledValue()}
            type="checkbox"
            value="1"
            checked={this.checkedValue()}
            name="shipping_label_form[signature_required]"
            id="shipping_label_form[signature_required]"
          />
          <label htmlFor="shipping_label_form[signature_required]" className="shipping-label__checkbox-label">
            {I18n.t('js.dashboard.selling.shippingLabels.signatureRequired.signatureRequiredTitle')}
          </label>
        </div>
        {this.showWarning()}
      </div>
    );
  }
}

SignatureRequiredInput.propTypes = {
  required: PropTypes.bool.isRequired,
  defaultChecked: PropTypes.bool.isRequired,
  toggleSignatureRequired: PropTypes.func.isRequired,
};

SignatureRequiredInput.defaultProps = {
  required: false,
  defaultChecked: true,
  toggleSignatureRequired: () => true,
};

module.exports = SignatureRequiredInput;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/signature_required_input.jsx